var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M43.56 34.64v-9.65c0-2.9-2.35-5.25-5.25-5.25H15.92a5.26 5.26 0 00-5.25 5.25v34.36c0 2.9 2.35 5.25 5.25 5.25h22.39c2.9 0 5.25-2.35 5.25-5.25V49.7m20.77-29.96v-4.09c0-2.9-2.35-5.25-5.25-5.25H35.76a4.32 4.32 0 00-4.32 4.32s0 0 0 0m17.13 40.54h10.5a5.26 5.26 0 005.26-5.25V30.73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke fill",
    d: "M19.87 42.17l14.49 13.1v-26.2l-14.49 13.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M34.36 42.17h20.72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.0decb279aad9d748570897e94b0deb09.svg";
export { ForwardRef as ReactComponent };